import { PropsWithChildren } from "react";
import { Box, useTheme } from "@mui/material";
import { bottomSafeArea, useConfigContext } from "@WahooFitness/wahoo-offline-mfe";

const EditWorkoutProfileWrapper = ({
  containedInDialog,
  children,
}: PropsWithChildren<{ containedInDialog?: boolean }>) => {
  const { globalBottomPadding } = useConfigContext();
  const { palette } = useTheme();
  if (containedInDialog) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        overflow="hidden"
        height="100dvh"
        pb={bottomSafeArea(globalBottomPadding)}
        bgcolor={palette.background.level1}
      >
        {children}
      </Box>
    );
  }
  return <Box>{children}</Box>;
};

export default EditWorkoutProfileWrapper;
